import React from "react";
import "./toast.scss";
import { TickForToast } from "../../SVG/tick-for-toast";
import { ErrorForToast } from "../../SVG/error-for-toast";
import { GreenCrossIcon } from "../../SVG/green-cross";
import { RedCrossIcon } from "../../SVG/red-cross";

interface ToastProps {
  type: "success" | "error";
  header: string;
  message?: string;
  duration?: number;
  id: string;
}

export const Toast: React.FC<ToastProps> = (props: ToastProps) => {
  const iconSrc =
    props.type === "success" ? <TickForToast /> : <ErrorForToast />;
  const iconClass =
    props.type === "success" ? <GreenCrossIcon /> : <RedCrossIcon />;
  const containerClass = props.type === "success" ? "success" : "error";

  const closeToast = () => {
    controlToastState(props.id, false);
  };

  return (
    <div className={`custom-toast-container ${containerClass} ${props.id}`}>
      <div className="custom-toast-icon">{iconSrc}</div>
      <div className={`custom-toast-content ${containerClass}`}>
        <div className="content-header">{props.header}</div>
        <div className="content-message">{props.message}</div>
      </div>
      <div className={`custom-toast-icon close`} onClick={closeToast}>
        <span className="alert-icons">{iconClass}</span>
      </div>
    </div>
  );
};

export const controlToastState = (id: string, state = true) => {
  const element = document.querySelector(`.custom-toast-container.${id}`);
  if (element) {
    element.classList.remove("show", "hide");
    element.classList.add(state ? "show" : "hide");

    if (state) {
      setTimeout(() => {
        element.classList.remove("show");
        element.classList.add("hide");
      }, 3000);
    }
  }
};
